import {
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux";
import BottomSheetModal from "../BottomSheetModal";
import { Colors } from "colors";
import VText from "components/VText";
import Svg, { Circle, Path } from "react-native-svg";
import { ActivityIndicator } from "react-native";
import { getSimilarProducts } from "src/redux/reducers/chatSlice";
import { Link } from "expo-router";
import OutfitSilder from "./outfitSilder";
import ExploreLookCommonModal from "./ExploreTheLookCommonModal/ExploreLookCommonModal";

const ExploreOutfits = React.forwardRef((props, ref) => {
  const { height, width } = useWindowDimensions();
  const _bottomSheetRef = useRef();
  const [similarProducts, setSimilarProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  React.useImperativeHandle(ref, () => ({ show, hide }), []);
  const dispatch = useDispatch();
  const _exploreLookCommonModalRef = useRef();

  const show = () => {
    _bottomSheetRef?.current?.show();
  };
  const hide = () => {
    _bottomSheetRef?.current?.hide();
  };

  return (
    <BottomSheetModal
      MAX_HEIGHT_PERC={1}
      START_PERC={1}
      ref={_bottomSheetRef}
      hideLine
      containerStyle={{
        backgroundColor: "transparent",
        zIndex: 100,
      }}
    >
      <TouchableOpacity
        style={{
          backgroundColor: "transparent",
          width,
          height,
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          zIndex: 100,
          cursor: "auto",
        }}
        activeOpacity={1}
        onPress={() => _bottomSheetRef?.current?.hide()}
      >
        <TouchableOpacity
          style={{
            width: wp(750),
            height: hp(750),
            backgroundColor: "#fff",
            cursor: "auto",
            overflowX: "hidden",
          }}
          activeOpacity={1}
        >
          <TouchableOpacity
            onPress={() => _bottomSheetRef?.current?.hide()}
            activeOpacity={0.8}
            style={{
              position: "absolute",
              right: 20,
              top: 20,
              zIndex: 100,
            }}
          >
            <Svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
              <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                fill="#212427"
              />
            </Svg>
          </TouchableOpacity>

          <View
            style={{
              paddingHorizontal: spH(5),
              paddingVertical: spV(25),
              alignItems: "center",
            }}
          >
            <VText
              style={{
                fontSize: fp(32),
                fontWeight: "500",
                color: "#21242799",
                marginBottom: spV(25),
                fontFamily: "LibreBodoni",
              }}
            >
              Shop the Look
            </VText>

            <View
              style={{ padding: spH(20), width: wp(745), overflow: "hidden" }}
            >
              {props?.data?.map((item, index) => (
                <React.Fragment key={index}>
                  <OutfitSilder
                    item={item}
                    _exploreLookCommonModalRef={_exploreLookCommonModalRef}
                  />
                </React.Fragment>
              ))}
            </View>
          </View>
        </TouchableOpacity>
      </TouchableOpacity>
      <ExploreLookCommonModal ref={_exploreLookCommonModalRef} />
    </BottomSheetModal>
  );
});

ExploreOutfits.displayName = "ExploreOutfits";
export default ExploreOutfits;

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    borderRadius: 8,
    width: wp(309),
  },
  image: {
    width: wp(309),
    height: hp(199),
  },
});
